<script>
import { createEventDispatcher } from 'svelte'
import { fly } from 'svelte/transition'
const dispatch = createEventDispatcher() 

export let cocktail = {}
</script>

<style>
#popup{
    margin:0px solid auto;
    position: fixed;
    top:50%;
    left:50%;
    margin-top:-330px;
    margin-left:-600px;
    width: 1100px;
    height: 650px;
    background: #090304;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    border-radius: 4px;
    z-index:1000;    
}
.left{ left:-27px; }
.right{ right:-27px; }

#closeBtn{
    position:absolute;
    top:20px;
    right:20px;
    cursor:pointer;
}
#cocktailImage{
    background-position:50% 50%;
    background-size:contain;
    background-repeat:no-repeat;
    height:550px;
    margin-top:80px;
}

@media all and (max-width:800px) {
    #cocktailImage{
        height:350px;
    }
    #popup{
        position:relative;
    }
}

.arrows{
    position:absolute;
    top:50%;     
    cursor:pointer;
}
a{ border:none; opacity:1; }
button svg path{ fill:#FFFFFF; }
button:hover svg path{ fill:#000000; }
h3{ text-align:left; }

.ingredients{ margin-top:40px; }
.ingredients .columns{ border-top:1px solid #FFFFFF33; }
.ingredients .columns .column:first-child{ border-right:1px solid #FFFFFF33; }

#list{ width:80%; margin-top:100px; }
#popup > .columns{ height:630px; }

#popupWrapper{ width:100%; }

@media (max-width: 768px){
    #popup{
        width:100%;
        top:0px;
        left:0px;
        margin-top:0px;
        margin-left:0px;
        height:auto;
        position:absolute;
        padding-left:20px;
        padding-right:20px;
    }
    #popup .arrows{ top:210px; }
    #popup .left{ left:0px; }
    #popup .right{ right:0px; }
    #cocktailImage{ margin:0px; }
    #list{ width:100%; margin-top:0px; }
    #popup > .columns{ height:auto; }
    .art{ display:none; }

    h1{ font-size:7vw; }
    #popupWrapper{ position:fixed; top:0px; left:0px; width:100%; height:100%; overflow-y:scroll; z-index:10001; }
}
</style>

<div id="popupWrapper">
    <div id="popup" class="container" transition:fly={{y:-50}}>
        <div class="columns">
            <div id="cocktailImage" class="column" style="background-image:url('./res/cocktails/{cocktail.img}.png');"></div>
            <div class="column" style="position:relative;">
                <img alt="Art" src="./res/popup-top-left.svg" style="position:absolute; top:21px; left:-91px;" class="art" />
                <img alt="Art" src="./res/popup-top-left.svg" style="position:absolute; bottom:0px; right:50px;" class="art" />

                <div id="list">
                    <h3>COCKTAIL</h3>
                    <h1>{cocktail.title}</h1>
                    <a href={cocktail.video} target="_blank">
                        <button>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.01" width="14" height="14" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1L14 7L0 13V1Z" />
                            </svg>
                            Watch
                        </button>
                    </a>
                    <p>{cocktail.desc}</p>

                    <div class="ingredients">
                        {#each cocktail.content as { ingredient , value }, i}
                        <div class="columns">                
                            <div class="column is-three-fifths">{ ingredient }</div>
                            <div class="column">{ value }</div>
                        </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>

        <img alt="Previous" src="./res/arrow-left.svg" class="arrows left" on:click={()=>dispatch('prev')} />
        <img alt="Next" src="./res/arrow-right.svg" class="arrows right" on:click={()=>dispatch('next')} />

        <img id="closeBtn" alt="Close button"  src="./res/btn-close.svg" on:click={()=>dispatch('close')}>
    </div>
</div>